import { Button } from "PFComponents/button";
import TextArea from "PFComponents/text/text_area";
import { useBookingApprovalReject } from "PFCore/hooks/queries/bookings/approvals/use_booking_approvals_reject";
import { BookingApproval } from "PFTypes";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./modals.module.scss";
import ApprovalModal from "./parts/approval_modal";
import ApprovalTable from "./parts/approval_table";

type IProps = {
  data: BookingApproval | BookingApproval[];
  handleClose: () => void;
  onSuccess?: (items?: BookingApproval[]) => void;
};

const Content = ({ data, handleClose, onSuccess }: IProps) => {
  const arrifiedData = [data].flat();
  const rejectableIds = arrifiedData.filter(({ state }) => state === "pending").map(({ id }) => id);
  const { reject } = useBookingApprovalReject(...rejectableIds);
  const { t } = useTranslation(["bookingModule", "translation"]);

  const [note, setNote] = useState(null);

  const handleSubmit = () => {
    const payload = { note };
    reject(payload).then(() => {
      handleClose();
      onSuccess && onSuccess(arrifiedData);
    });
  };

  return (
    <>
      <h3 className={css.title}>{t("bookingModule:approvals.rejectApproval")}</h3>
      <ApprovalTable data={data} />
      <div className={css.inputWrapper}>
        <div className={css.label}>{t("bookingModule:approvals.reasonForRejection")}</div>
        <TextArea
          className={css.textArea}
          controlledValue
          value={note}
          onChange={setNote}
          maxLength={280}
          maxHeight={200}
        />
      </div>
      <hr className={css.separator} />
      <div className={css.buttons}>
        <Button text={t("translation:cancel")} kind="tertiary" onClick={handleClose} />
        <Button text={t("translation:reject")} kind="primary" disabled={!note} onClick={handleSubmit} />
      </div>
    </>
  );
};

const RejectApprovalModal = ({ handleClose, ...props }: IProps) => (
  <ApprovalModal qaId="bookingRejectApprovalModal" handleClose={handleClose}>
    <Content handleClose={handleClose} {...props} />
  </ApprovalModal>
);

export default RejectApprovalModal;
